<adapt-toolbar-content alignment="center">
    <h2>Our values</h2>
</adapt-toolbar-content>

<div adaptToolbarContent>
    @if (isEditing) {
        <button adaptButtonIcon="add"
                [adaptBlockingClick]="addValue"
                data-test="add-value-button">Add value</button>
    }
    @if (isEditing) {
        <button adaptButton="view"
                data-test="view-mode-button"
                (click)="isEditing = false"></button>
    }
    @if ((canEditValuesConstitution$ | async) && !isEditing) {
        <button adaptButton="edit"
                data-test="edit-mode-button"
                (click)="isEditing = true"
                data-tour="values-edit"></button>
    }
</div>

<adapt-context-sidebar-implementation-kit [articleId]="ImplementationKitArticle.SetValuesOutcomes"
                                          [fullScreen]="true"
                                          title="Values"
                                          context="page"></adapt-context-sidebar-implementation-kit>

@if (valuesConstitution$ | async; as valuesConstitution) {
    <adapt-values-constitution [valuesConstitution]="valuesConstitution"
                               [isEditing]="isEditing"
                               data-tour="values-card"> </adapt-values-constitution>
} @else {
    <adapt-call-to-action [learnMoreUrl]="learnMoreUrl">
        <adapt-call-to-action-title>Values</adapt-call-to-action-title>
        <p>Adapt's values tool provides a place to capture and maintain your organisation's values.</p>
        @if (canEditValuesConstitution$ | async) {
            <button adaptCallToActionButton
                    adaptButtonIcon="add"
                    [adaptBlockingClick]="addValue">Add value</button>
        }
    </adapt-call-to-action>
}

@if ((valuesConstitution$ | async)?.lastUpdated; as lastUpdated) {
    <adapt-entity-timestamp class="text-muted"
                            [timestamp]="lastUpdated"
                            prefix="Last updated"></adapt-entity-timestamp>
}
